import EditSite  from './EditSite';

export default EditSite;



// WEBPACK FOOTER //
// ./src/app/views/admin/manageSite/index.js